/**
 * @generated SignedSource<<dec983d9db54356e7b52612ebd8e07b2>>
 * @relayHash cf2fd9709cd91b06ae7d93597ce4abd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00a59505c39bdec9611c09609b088eb9b01dc4a27e481b28382e3db659bcec17

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type JiraUpdateVersionReleasedStatusInput = {
  id: string;
  isReleased: boolean;
};
export type actions_updateVersionReleasedMutation$variables = {
  input: JiraUpdateVersionReleasedStatusInput;
};
export type actions_updateVersionReleasedMutation$data = {
  readonly jira: {
    readonly updateVersionReleasedStatus: {
      readonly success: boolean;
      readonly version: {
        readonly status: JiraVersionStatus | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type actions_updateVersionReleasedMutation = {
  response: actions_updateVersionReleasedMutation$data;
  variables: actions_updateVersionReleasedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "status"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "actions_updateVersionReleasedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionReleasedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "actions_updateVersionReleasedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionReleasedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "00a59505c39bdec9611c09609b088eb9b01dc4a27e481b28382e3db659bcec17",
    "metadata": {},
    "name": "actions_updateVersionReleasedMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "de8237e18f09aa8fe2fa05dd5d8cd028";

export default node;
